import * as d3 from 'd3'

export default {

  methods: {

    draw_Circle(selection, cx, col, prog) {

      let cir = this.circle
      let endAn = ''

      cir.back.radius = cir.front.radius - ((cir.front.thick - cir.back.thick)/2)

      let arc1 = d3.arc()
      .outerRadius(cir.back.radius)
      .innerRadius(cir.back.radius - cir.back.thick)
      .startAngle(Math.PI / 180)
      .endAngle(() => endAn || 360 * Math.PI / 180)

      let arc2 = d3.arc()
      .outerRadius(cir.front.radius)
      .innerRadius(cir.front.radius - cir.front.thick)
      .startAngle(Math.PI / 180)
      .endAngle(() => endAn || 360 * Math.PI / 180)
      .cornerRadius(cir.front.thick)

      let chart = selection
      .append('g')
      .attr('transform', `translate(${cx}, ${cir.y})`)

      chart
      .append('path')
      .attr('d', arc1).attr('fill', cir.back.color).attr('opacity', cir.back.opacity)

      if(prog==0) return
      chart
      .append('path')
      .attr('d', arc2)
      .attr('fill', col.color).attr('opacity', cir.front.opacity)
      .transition().duration(500)
      .attrTween('d', ()=> {
        let endAngle_ = ( ((360 * (prog/100)) ) * Math.PI / 180)
        let interpolate = d3.interpolate(0 * Math.PI / 180, endAngle_)
        return function(t) {
          endAn = interpolate(t)
          return arc2()
        }
      })
    },

  } 
}